define('core/i18n',['require','ns','i18n/en-us','i18n/zh-hk','i18n/zh-cn'],function (require) {
	'use strict';

	var ns = require('ns');

	require('i18n/en-us');
	require('i18n/zh-hk');
	require('i18n/zh-cn');

	var _resource = {};

	var I18n = function () {
		
		var currentLocale = ns.config.get('currentLocale');
		
		if (!ns.resources[currentLocale]) {

			ns.logger.error('I18n', 'resource [' + currentLocale + '] not exist');
			
			var defaultLocale = ns.config.get('defaultLocale');
			
			currentLocale = defaultLocale;
		}
		
		var attemptedResources = ns.resources[currentLocale];
				
		if (!attemptedResources) {

			throw new TypeError('I18n#constructor: resource [' + currentLocale + '] not exist');
		}
		
		ns.logger.info('I18n', 'use resource: ' + currentLocale);
		
		_resource = attemptedResources;
	};

	I18n.prototype = {

		get: function (key) {

			return _resource[key] || '';
		}
	};

	return I18n;
});
